import api from "./client";
import logger from "../utils/logger";

function asArray(val) {
  if (Array.isArray(val)) return val;
  if (val?.data && Array.isArray(val.data)) return val.data;
  if (val?.data?.data && Array.isArray(val.data.data)) return val.data.data;
  return [];
}

/**
 * Get all conversations for the authenticated user
 */
export async function getConversations() {
  try {
    const res = await api.apiGet("v1/conversations").catch(() => api.apiGet("conversations"));
    return asArray(res?.data || res);
  } catch (err) {
    logger.error("Failed to fetch conversations", err);
    return [];
  }
}

/**
 * Get single conversation with full details & messages
 */
export async function getConversationDetails(conversationId) {
  if (!conversationId) return null;
  try {
    const res = await api.apiGet(`v1/conversations/${conversationId}`).catch(() => api.apiGet(`conversations/${conversationId}`));
    return res?.data?.data || res?.data || res || null;
  } catch (err) {
    logger.error(`Failed to fetch conversation #${conversationId}`, err);
    throw err;
  }
}

/**
 * Get paginated messages for a conversation
 */
export async function getConversationMessages(conversationId) {
  if (!conversationId) return [];
  try {
    const res = await api.apiGet(`v1/conversations/${conversationId}/messages`).catch(() => api.apiGet(`conversations/${conversationId}/messages`));
    return asArray(res?.data || res);
  } catch (err) {
    logger.error(`Failed to fetch messages for conversation #${conversationId}`, err);
    return [];
  }
}

/**
 * Send message in a conversation (text and/or attachment)
 */
export async function sendConversationMessage(conversationId, payload) {
  if (!conversationId) throw new Error("Missing conversation ID");
  try {
    // If payload is FormData or plain object
    const res = await api.apiPost(`v1/conversations/${conversationId}/messages`, payload).catch(() =>
      api.apiPost(`conversations/${conversationId}/messages`, payload)
    );
    return res?.data?.data || res?.data || res;
  } catch (err) {
    logger.error(`Failed to send message in conversation #${conversationId}`, err);
    throw err;
  }
}

/**
 * Create or open existing conversation with a freelancer / client
 */
export async function createOrGetConversation(freelancerId, serviceId = null) {
  try {
    const body = { freelancer_id: Number(freelancerId) };
    if (serviceId) body.service_id = Number(serviceId);

    const res = await api.apiPost("v1/conversations", body).catch(() => api.apiPost("conversations", body));
    return res?.data?.data || res?.data || res;
  } catch (err) {
    logger.error("Failed to create or fetch conversation", err);
    throw err;
  }
}
